

import React, { Component } from 'react'
import moment from 'moment';

const DAYS_OF_WEEK = [
    'söndag',
    'måndag',
    'tisdag',
    'onsdag',
    'torsdag',
    'fredag',
    'lördag'
];

class DayOfWeekComponent extends Component {
    render() {
        const { date } = this.props;

        const momentDate = moment(date, "YYYY-MM-DD", true);

        if(!momentDate.isValid()){
            return (<span>Ogiltigt datum</span>);
        }

        return (<span>{DAYS_OF_WEEK[momentDate.day()]}</span>)
    }
}

export default DayOfWeekComponent;


// WEBPACK FOOTER //
// ./src/components/dayOfWeek.js